/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import queryString from 'query-string'

import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import './styles.scss'
import '../globals.scss'

import { Link } from '@ta-interaktiv/contentbricks'

// import { NewCasesSmallMultiples } from 'components/newCasesSmallMultiples'

// import { Masthead } from '@ta-interaktiv/react-masthead'
// import { Footer } from '@ta-interaktiv/react-footer'
// import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { isMobile } from './config.tsx'

import { Facts } from 'components/Facts'
import { parseHostname } from '@ta-interaktiv/parse-hostname'

// TODO Set the correct article ID here
const ARTICLE_ID = '00000000'

const qs = queryString.parse(location.search)
const canton = qs.canton ? qs.canton.toUpperCase() : 'ZH'

export function AppComponent() {
  return (
    <div className='index'>
      <Facts mobile={isMobile} canton={canton} />
      <Link
        href={
          'https://interaktiv.' +
          parseHostname().publicationDomain +
          '/2020/covid-19-ausbruch-im-vergleich/'
        }
        className='dashboard'
      >
        Alle Zahlen zum Covid-19-Ausbruch
      </Link>
    </div>
  )
}
